const TECHNICIAN_GROUP_NAME = "technician";

type CanDeleteFileArgs = {
  uploadedBy?: number | null;
  currentUserId?: number;
  currentUserGroups?: string[];
};

/**
 * UX-layer visibility rule for the file delete control. The backend guard is the
 * real enforcement; this only decides whether the delete button is shown, and
 * mirrors that guard exactly.
 *
 * Staff (managers, coordinators, administrators) may delete any file. Technicians
 * may delete only their own uploads - the control is hidden on files uploaded by
 * someone else and on files with no recorded uploader (legacy or ticket-less
 * uploads carry a null uploaded_by).
 */
export function canDeleteFile({
  uploadedBy,
  currentUserId,
  currentUserGroups,
}: CanDeleteFileArgs): boolean {
  if (currentUserId == null) {
    return false;
  }
  const isTechnician = (currentUserGroups ?? []).some(
    (group) => group.toLowerCase() === TECHNICIAN_GROUP_NAME
  );
  if (!isTechnician) {
    return true;
  }
  return uploadedBy === currentUserId;
}
